import { useContext, useEffect, useState } from 'react';
import {
    filterDataByPeerFilters,
    filterDataByPortfolioLongName,
    isAnyFilterSet
} from '../functions/filtering';
import { applyVictoryOrdering } from '../functions/dataFormatting';
import {
    FilterStatesContext,
    PEER_FILTER_ACTIONS
} from '../components/contexts/filterStates';

/** @function
 * Sets up peer filtering on a dataset.
 *
 * @param data {Object<Array>}
 * @returns {{filteredData: unknown}}
 */
export function useFilteredData(data) {
    const filterState = useContext(FilterStatesContext);
    const [filteredData, setFilteredData] = useState(null);

    /**
     * Runs on data state change to fetch the benchmark data using the api
     */
    useEffect(() => {
        if (data) {
            filterState.peerFilterDispatch({
                type: PEER_FILTER_ACTIONS.SET_OPTIONS,
                payload: data
            });
            setFilteredData(data);
        }
    }, [data]);

    /**
     * Runs whenever the peer filters values are updated, filters full data set by both search state and peer filter state.
     */
    useEffect(() => {
        if (data && !filterState.peerFilterStates.optionsUpdated) {
            isAnyFilterSet(filterState)
                ? setFilteredData(
                      applyVictoryOrdering(
                          filterDataByPeerFilters(
                              filterDataByPortfolioLongName(
                                  data,
                                  filterState.searchState
                              ),
                              filterState.peerFilterStates
                          )
                      )
                  )
                : setFilteredData(data);
        }
    }, [filterState.peerFilterStates]);

    /**
     * Runs whenever the search bar state is updated, filters by the search state,
     * updates the filter dropdown options, then also filters by the peer filters state.
     */
    useEffect(() => {
        if (data) {
            let tempFilteredData = filterDataByPortfolioLongName(
                data,
                filterState.searchState
            );

            filterState.peerFilterDispatch({
                type: PEER_FILTER_ACTIONS.SET_OPTIONS,
                payload: tempFilteredData
            });

            setFilteredData(
                applyVictoryOrdering(
                    filterDataByPeerFilters(
                        tempFilteredData,
                        filterState.peerFilterStates
                    )
                )
            );
        }
    }, [filterState.searchState]);

    return {
        filteredData
    };
}
